import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Clock = (props: SVGIcon) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      d="M11.98 0c6.607 0 11.982 5.375 11.982 11.98 0 6.607-5.375 11.982-11.981 11.982S0 18.587 0 11.98 5.375 0 11.98 0zm0 1.498C6.2 1.498 1.499 6.2 1.499 11.98c0 5.78 4.702 10.483 10.483 10.483 5.78 0 10.483-4.702 10.483-10.483 0-5.78-4.702-10.483-10.483-10.483zm.75 2.995v7.178l4.273 4.273-1.059 1.06-4.712-4.713V4.493h1.498z"
    />
  </svg>
)
